<template>

    <div class="flex h-screen">
        <div class="m-auto">
            <div class="flex min-h-full items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
                <div class="w-full max-w-md space-y-8">
                    <div>
                        <img class="mx-auto h-12 w-auto"
                            src="/img/logo.svg" alt="Logo A Bit Safer Today">
                        <h2 class="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">Bevestig uw account</h2>
                        <p class="mt-2 text-center text-sm text-gray-600">
                            Om het beveiligde formulier te bekijken
                        </p>
                    </div>
                    <form class="mt-8 space-y-6" action="#">
                        <input type="hidden" name="remember" value="true">
                        <div class="-space-y-px rounded-md shadow-sm">
                            <div>
                                <label for="email-address" class="sr-only">Zakelijke e-mail adres</label>
                                <input id="email-address" name="email" type="email" autocomplete="email" required
                                    class="relative block w-full appearance-none rounded-none rounded-t-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                    placeholder="naam@organisatie.nl">
                            </div>
                            <div>
                                <label for="password" class="sr-only">Wachtwoord</label>
                                <input id="password" name="password" type="password" autocomplete="current-password"
                                    required
                                    class="relative block w-full appearance-none rounded-none rounded-b-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                    placeholder="Wachtwoord">
                            </div>
                        </div>

                        <div class="text-sm" @click="toggleInfoBox()" >
                            <a href="#" class="font-medium text-teal-400 hover:text-teal-300">Waarom zie ik dit?</a>
                        </div>

                        <div>
                            <button type="submit"
                                class="group relative flex w-full justify-center rounded-md border border-transparent bg-teal-500 py-2 px-4 text-sm font-medium text-white hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                                <span class="absolute inset-y-0 left-0 flex items-center pl-3">
                                    <svg class="h-5 w-5 text-white group-hover:text-white"
                                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                        aria-hidden="true">
                                        <path fill-rule="evenodd"
                                            d="M10 1a4.5 4.5 0 00-4.5 4.5V9H5a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2h-.5V5.5A4.5 4.5 0 0010 1zm3 8V5.5a3 3 0 10-6 0V9h6z"
                                            clip-rule="evenodd" />
                                    </svg>
                                </span>
                                Bevestig
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div id="infoDiv" class="flex justify-center h-screen w-screen p-24 fixed top-0 left-0 items-center rounded-md shadow-xl bg-white" v-if="this.infoBox == true" >
            <div class="m-auto" >
                <div class="p-8 w-full max-w-md space-y-8" >
                    <a href="#">
                        <svg @click="toggleInfoBox()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6" >
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </a>

                    <img class="mx-auto h-12 w-auto" src="/img/logo.svg" alt="Logo A Bit Safer Today" />
                    <p class="mt-2 text-center text-sm text-gray-600">
                        U moet uw accountgegevens bevestigen omdat u waarschijnlijk een document/formulier probeert te bereiken die alleen beschikbaar is via uw organisatie. 
                        <br/><br/>
                        Om deze veiligheid te garanderen moet u via ons uw account verifiëren. Als uw gegevens goedgekeurd zijn dan geven wij u toegang tot het opgevraagde document/formulier.
                        <br/><br/>
                    </p>
                    <div>
                        <p class="mx-auto w-auto mt-2 text-center text-sm text-gray-600">A bit safer.today, de digital wereld, dagelijks, een stukje veiliger.</p>
                    </div>
                </div>
            </div>
            
        </div>

    </div>
</template>

<script>

export default {
    props: {

    },

    components: {

    },

    data: () => ({
        infoBox: false,
    }),

    methods: {
        toggleInfoBox(){
            if (!this.infoBox) {
                this.infoBox = true;
                return
            }
            this.infoBox = false;
        }
    }
}

</script>